package ai.wagemix.net.models

/** The latest progress of a job-description upload or re-evaluation, keyed by its event-stream id. */
interface WMUploadProgress {
    val message: String
    val inProgress: Boolean
    val successful: Boolean
    /** The stored mix the pipeline produced; `null` until it finishes successfully. */
    val mixId: String?

    companion object
}

fun WMUploadProgress.Companion.of(message: String, inProgress: Boolean, successful: Boolean, mixId: String?): WMUploadProgress {
    return WMUploadProgressData(message = message, inProgress = inProgress, successful = successful, mixId = mixId)
}

private data class WMUploadProgressData(
    override val message: String,
    override val inProgress: Boolean,
    override val successful: Boolean,
    override val mixId: String?
): WMUploadProgress
